module.exports = __webpack_public_path__ + "img/helper@2x.c73ae19b.png";